import { Card, CardContent, CardHeader, CardTitle } from '@cibli/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PictureCapture from '@/features/picture/components/PictureCapture';

import { ApiInfoCard } from './ApiInfoCard';
import AppManagement from './AppManagement';
import { DeploymentInfoCard } from './DeploymentInfoCard';
import { DeviceInfo } from './DeviceInfo';
import DevicesSettings from './DeviceSettings';
import { FeatureFlagsCard } from './FeatureFlagsCard';
import { NetworkSpeedCard } from './NetworkSpeedCard';
import PrinterSettings from './PrinterSettings';

interface Props {
  onClose: () => void;
}

export const Settings = ({ onClose }: Props) => {
  const [picture, setPicture] = useState<string | null>(null);
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <DeploymentInfoCard />
      <ApiInfoCard />
      <NetworkSpeedCard />
      <DeviceInfo />
      <DevicesSettings />
      <PrinterSettings />
      <Card>
        <CardHeader>
          <CardTitle>{t('Settings.video')}</CardTitle>
        </CardHeader>
        <CardContent>
          <PictureCapture
            initialImage={picture}
            onImageCapture={setPicture}
            size="lg"
            showSettings={true}
          />
        </CardContent>
      </Card>

      <FeatureFlagsCard />
      <AppManagement onClose={onClose} />
    </div>
  );
};
